import { FAQSection } from "@modules/study/common/sections";
import { useRef } from "react";
import { getAssets } from "@unisearch/helpers";
import Link from "next/link";
import { Fragment } from "react";
import { FaMapMarkerAlt } from "react-icons/fa";
import { HiPhone } from "react-icons/hi";
import { MdMail } from "react-icons/md";
import { ReactSVG } from "react-svg";
import styles from "./consultants.module.scss";
import { useEffect, useState } from "react";
import { BsStar, BsStarFill, BsStarHalf } from "react-icons/bs";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import "react-multi-carousel/lib/styles.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import { LeadForm } from "@modules/lead/components";

const faqData = [
  {
    id: 1,
    faqQuestion: "1. Is there a charge for UniSearch’s counselling services?",
    faqAnswer:
      "<p>No, UniSearch does not charge you for our study abroad counselling services! When you are applying to the UK, Australia, Canada, Ireland and/or New Zealand, fees are only payable to the university, immigration bodies, and other relevant authorities involved in your application.</p><p>If you are planning on applying to the USA, we do charge a fee to cover the administrative costs of completing the process!</p>",
  },
  {
    id: 2,
    faqQuestion:
      "2. Can you help me with my university and visa application to study abroad?",
    faqAnswer:
      "<p>Of course, that’s exactly what UniSearch is here to do! As the top study abroad consultants in Bangalore and India, we pride ourselves for our complete end-to-end support of our students before, during, and after the application process. We guide you through your program and university research with tailored shortlists matching your profile and preferences. We then support you through the full application process - including guidance for your LOR and SOP, English language tests, and scholarship applications. Our support goes beyond your applications too - we assist with visa processing, as well as accommodation search and student job opportunities at your destination.</p>",
  },
  {
    id: 3,
    faqQuestion: "3. Can you help me get a scholarship to study abroad?",
    faqAnswer:
      "<p>Our overseas education counsellors help you discover scholarship opportunities that you are eligible for and support your applications! You can also access education loan support through UniSearch.</p>",
  },
  {
    id: 4,
    faqQuestion:
      "4. Can you help me find accommodation at my study abroad destination?",
    faqAnswer:
      "<p>UniSearch works with several accommodation providers in major study abroad destinations to help you secure student housing.</p>",
  },
  {
    id: 5,
    faqQuestion: "5. Does UniSearch waive application fees for students?",
    faqAnswer:
      "<p>You’re in luck, because yes, we do! As top overseas education consultants, several of our partner universities waive application fee requirements for our students. Get in touch with us to find out which universities you can apply to without an application fee!</p>",
  },
  {
    id: 6,
    faqQuestion: "6. Can UniSearch help me with my SOP and LOR?",
    faqAnswer:
      "<p>Our expert team of international education consultants have decades of experience helping students craft successful applications. And this expertise includes helping students put together impactful statements of purpose (SOP) and letters of reference/referral (LOR)!</p>",
  },
  {
    id: 7,
    faqQuestion:
      "7. I can’t visit UniSearch in-person - can you still help me?",
    faqAnswer:
      "<p>We definitely can! Our core commitment at UniSearch is to help every student access their ideal study abroad journey. Along with our physical branches, you can also connect with the best study abroad consultants in Bangalore and India through our <a class='color-orange fw600' href='https://us06web.zoom.us/j/94960983299?pwd=N093UkVZd0JoMXczbmdhdTl4cWJ6UT09' target='_blank' rel='nofollow' >virtual office.</a></p>",
  },
];

const ConsultantsInBangalore = ({ pageData }) => {
  const ref = useRef(null);
  const handleClick = () => {
    ref.current?.scrollIntoView({ behavior: "smooth" });
  };

  const [nav1, setNav1] = useState(null);
  const [nav2, setNav2] = useState(null);
  const [slider1, setSlider1] = useState(null);
  const [slider2, setSlider2] = useState(null);

  function NextArrow(props) {
    const { className, style, onClick } = props;
    return (
      <FiChevronRight
        className={`${className} ReviewSliderTextArrowNext`}
        onClick={onClick}
      />
    );
  }

  function PrevArrow(props) {
    const { className, style, onClick } = props;
    return (
      <FiChevronLeft
        className={`${className} ReviewSliderTextArrowPrev`}
        onClick={onClick}
      />
    );
  }

  useEffect(() => {
    setNav1(slider1);
    setNav2(slider2);
  });

  const settingsMain = {
    asNavFor: ".slider-nav",
    arrows: true,
    centerMode: false,
    infinite: false,
    centerPadding: "20px 0px",
    slidesToShow: 1,
    speed: 500,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  const settingsThumbs = {
    slidesToShow: 5,
    slidesToScroll: 1,
    asNavFor: ".slider-for",
    dots: false,
    arrows: false,
    centerMode: true,
    focusOnSelect: false,
    swipeToSlide: false,
    draggable: false,
    responsive: [
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          arrows: true,
          dots: false,
          centerMode: false,
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <Fragment>
      {/* section hero */}
      <section className={styles.section_hero}>
        <div className="container">
          <div className={styles.hero_wrapper}>
            <div className={styles.heading_wrapper}>
              <h1>
                Welcome to <br /> UniSearch{" "}
                <span className="color-orange">Bangalore</span>
              </h1>

              <div className={styles.destination_heading}>
                Popular Destinations:
              </div>
              <div className={styles.destination_country_wrapper}>
                <ul>
                  <li>
                    <ReactSVG
                      src={getAssets(
                        "assets/images/consultant/icon/australia.svg"
                      )}
                    />
                    <span>Australia</span>
                  </li>
                  <li>
                    <ReactSVG
                      src={getAssets(
                        "assets/images/consultant/icon/canada.svg"
                      )}
                    />
                    <span>Canada</span>
                  </li>
                  <li>
                    <ReactSVG
                      src={getAssets(
                        "assets/images/consultant/icon/ireland.svg"
                      )}
                    />
                    <span>Ireland</span>
                  </li>
                  <li>
                    <ReactSVG
                      src={getAssets(
                        "assets/images/consultant/icon/new-zealand.svg"
                      )}
                    />
                    <span>New Zealand</span>
                  </li>
                  <li>
                    <ReactSVG
                      src={getAssets("assets/images/consultant/icon/usa.svg")}
                    />
                    <span>United State</span>
                  </li>
                  <li>
                    <ReactSVG
                      src={getAssets("assets/images/consultant/icon/uk.svg")}
                    />
                    <span>United Kingdom</span>
                  </li>
                </ul>
              </div>
              <button
                onClick={handleClick}
                className="btn btn-md btn-secondary"
                style={{ width: "max-content" }}
              >
                Book your slot
              </button>
            </div>
            <div className={styles.destination_img_wrapper}>
              <img
                src={getAssets(
                  "assets/images/consultant/welcome-to-uniSearch-bangalore.png"
                )}
                alt="Welcome to UniSearch Bangalore"
              />

              <div className={styles.student_count_wrapper}>
                <ReactSVG
                  src={getAssets("assets/images/consultant/icon/students.svg")}
                />
                <div className={styles.student_description}>
                  <h4>100,000+ Students</h4>
                  <p>Service Provide</p>
                </div>
              </div>
              <div className={styles.student_comunity_wrapper}>
                <div>
                  <span className={styles.satisfied_student}>
                    Our Satisfied Student Community
                  </span>
                  <span className={styles.active_user}>
                    Over 100,000 active users
                  </span>
                  <img
                    src={getAssets("assets/images/consultant/comunity.png")}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* section description */}
      <section className={styles.section_description}>
        <div className="container">
          <h2 className={styles.desc_heading}>
            Study Abroad <br />{" "}
            <span className="color-orange"> Consultants in Bangalore</span>
          </h2>
          <p>
            Planning to study abroad but confused about how to get going? That’s
            where UniSearch - the best overseas education consultants in
            Bangalore - comes in. Our goal at UniSearch is simple - we strive to
            make the right study abroad solution available for every student, at
            every stage of their journey.
          </p>
          <p>
            UniSearch Bangalore’s study abroad consultants have helped thousands
            of students like you to secure admissions and visa applications for
            their dream universities. With over 20 years of experience, they
            help you discover your ideal program and{" "}
            <Link legacyBehavior href="/explore-university">
              <a>universities</a>
            </Link>{" "}
            from across the six popular destinations:{" "}
            <Link legacyBehavior href="/australia/university">
              <a>Australia, </a>
            </Link>{" "}
            <Link legacyBehavior href="/canada/university">
              <a>Canada, </a>
            </Link>{" "}
            <Link legacyBehavior href="/ireland/university">
              <a>Ireland, </a>
            </Link>
            <Link legacyBehavior href="/new-zealand/university">
              <a>New Zealand,</a>
            </Link>{" "}
            <Link legacyBehavior href="/united-states/university">
              <a>the UK, </a>
            </Link>{" "}
            and{" "}
            <Link legacyBehavior href="/united-states/university">
              <a>the USA</a>
            </Link>
            . Whether you’re visiting us in person at our Bangalore branch, or
            connecting with us remotely through our virtual office, our overseas
            education consultants commit to making your study abroad journey as
            smooth as possible.
          </p>
          <p>
            We offer end-to-end assistance in shortlisting programs and
            universities as well as the complete application process. This
            includes assistance finding and applying for scholarships and
            education loans, getting English language test training, and LOR and
            SOP guidance. In fact, our study abroad counsellors take their
            support even further with visa counselling, overseas health cover
            selection, accommodation booking, and student job advice.
          </p>
        </div>
      </section>

      {/* section offer */}
      <section className={styles.section_unisearch_offer}>
        <div className="container">
          <div className={styles.offers_wrapper}>
            <h2>
              As top study abroad consultants in Bangalore,<br></br>
              <span className="color-orange">UniSearch offers you</span>
            </h2>
          </div>
          <div className={styles.offer_card_wrapper}>
            <div className={`${styles.offer_card} ${styles.blue}`}>
              <ReactSVG
                src={getAssets("assets/images/consultant/icon/program.svg")}
              />
              <div>University and Program Shortlisting</div>
            </div>
            <div className={`${styles.offer_card} ${styles.light_orange}`}>
              <ReactSVG
                src={getAssets("assets/images/consultant/icon/application.svg")}
              />
              <div>End-to-End Application Support</div>
            </div>
            <div className={`${styles.offer_card} ${styles.dark_orange}`}>
              <ReactSVG
                src={getAssets("assets/images/consultant/icon/language.svg")}
              />
              <div>English Language Test Training</div>
            </div>
            <div className={`${styles.offer_card} ${styles.gray}`}>
              <ReactSVG
                src={getAssets("assets/images/consultant/icon/education.svg")}
              />
              <div>Scholarship and Education Loan Assistance</div>
            </div>

            <div className={`${styles.offer_card} ${styles.green}`}>
              <ReactSVG
                src={getAssets("assets/images/consultant/icon/visa.svg")}
              />
              <div>Visa Counselling</div>
            </div>

            <div className={`${styles.offer_card} ${styles.dark_orange}`}>
              <ReactSVG
                src={getAssets("assets/images/consultant/icon/health.svg")}
              />
              <div>Overseas Health Education Cover</div>
            </div>

            <div className={`${styles.offer_card} ${styles.blue}`}>
              <ReactSVG
                src={getAssets(
                  "assets/images/consultant/icon/accomodation.svg"
                )}
              />
              <div>Accommodation and Housing Search</div>
            </div>

            <div className={`${styles.offer_card} ${styles.light_orange}`}>
              <ReactSVG
                src={getAssets("assets/images/consultant/icon/job.svg")}
              />
              <div>On-Shore Student Job Guidance</div>
            </div>
          </div>
        </div>
      </section>

      {/* section support */}
      <section className={styles.section_support}>
        <div className="container">
          <div className={styles.support_wrapepr}>
            <div className="from_texteditor_wrapper">
              <h2>
                UniSearch Supports You Through Every Stage of{" "}
                <span className="color-orange">Studying Abroad</span>
              </h2>
              <ul className="">
                <li>In-person counselling at our branch offices</li>
                <li>Virtual counselling available remotely 12 hours a day</li>
                <li>Tailored study abroad opportunities for each student</li>
                <li>
                  End-to-end support before, during, and after application
                </li>
              </ul>
            </div>
            <div className={styles.unisearch_support_wrapper}>
              <img
                src={getAssets(
                  "assets/images/consultant/unisearch-support.png"
                )}
                alt="Welcome to UniSearch Bangalore"
              />
              <div className={styles.unisearch_support}>
                <ReactSVG
                  src={getAssets(
                    "assets/images/consultant/icon/university.svg"
                  )}
                />
                <div className={styles.student_description}>
                  <h4>500+ University</h4>
                  <p>Find the right fit for you</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* section Target English Language */}
      <section className={`${styles.section_support}`}>
        <div className="container">
          <div className={`${styles.support_wrapepr}`}>
            <div className={`${styles.english_test} relative`}>
              <img
                src={getAssets(
                  "assets/images/consultant/language-test-band.png"
                )}
                alt="Welcome to UniSearch Bangalore"
              />
              <div
                className={`${styles.student_count_wrapper}  ${styles.satisfied_student}`}
              >
                <ReactSVG
                  src={getAssets("assets/images/consultant/icon/graduate.svg")}
                />
                <div className={`${styles.student_description}`}>
                  <h4>3,950+</h4>
                  <p>Satisfied Student</p>
                </div>
              </div>
            </div>
            <div className="from_texteditor_wrapper">
              <h2>
                Score Your Target English Language{" "}
                <span className="color-orange">Test Bands</span>
              </h2>
              <p>
                As the most comprehensive overseas education consultants in
                Bangalore, UniSearch prepares you for success with English
                language test training. Our IELTS and PTE Academic courses and
                masterclasses are designed and held by certified trainers with a
                track record of impressive scores in India and overseas. Courses
                and masterclasses are available both online and offline, with
                flexible plans to choose the right option for you.
              </p>

              <ul className="">
                <li>
                  Insider tips, tricks, and strategies from experienced trainers
                </li>
                <li>Personalised learning with smaller classes</li>
                <li>Official study resources from test providers</li>
                <li>Practice sessions and evaluations</li>
                <li>Mock tests simulating the real exams</li>
                <li>Sessions for doubt-clearing</li>
                <li>On- and offline classes</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* section location */}
      <section
        className={styles.section_location}
        style={{ position: "relative" }}
      >
        <div className={styles.address_wrapper}>
          <div className="container">
            <div className={styles.address_container}>
              <div></div>
              <div className={styles.empty_div}></div>
              <div
                className={`${styles.address_card_wrapper} ${styles.address_card_location} ${styles.location_card}`}
              >
                <div className={styles.address_card_location_heading}>
                  Location:
                </div>
                <ul>
                  <li>
                    <FaMapMarkerAlt style={{ color: "#1198FC" }} />
                    <div>
                      <div className={styles.location_title}>Address:</div>
                      <div>
                        2nd Floor, RR Image, 4th Cross, Pandurang Nagar,
                        Bannerghatta Main Road, Bangalore 560076.
                      </div>
                    </div>
                  </li>
                  <li>
                    <MdMail style={{ color: "#4AC8A6" }} />
                    <div>
                      <div className={styles.location_title}>Email:</div>
                      <a href="mailto:info.bangalore@myunisearch.com">
                        info.bangalore@myunisearch.com
                      </a>
                    </div>
                  </li>
                  <li>
                    <HiPhone style={{ color: "#5D5FEF" }} />
                    <div>
                      <div className={styles.location_title}>Phone:</div>
                      <a href="tel:080-49779636">080-49779636</a>
                    </div>
                  </li>
                </ul>
              </div>

              <div className={styles.address_card_wrapper}>
                <ReactSVG
                  src={getAssets("assets/images/consultant/icon/address.svg")}
                />
                <div className={styles.location_title_two}>Location Guide</div>
                <div>
                  Proceed along the Bannerghatta Main Road, reaching Arekere
                  Gate. Move forward to Vasudev Adigas Hotel. UniSearch is 100
                  metres away from this destination.
                </div>
              </div>

              <div className={styles.address_card_wrapper}>
                <ReactSVG
                  src={getAssets("assets/images/consultant/icon/bus.svg")}
                />
                <div className={styles.location_title_two}>Location Guide</div>
                <div>
                  from Kempegowda Bus Station/Majestic to Arekere Gate 364A,
                  364F, 364H, 365, 365A, 365B, 365D, 365E, 365F, 365J, 365K,
                  365L, 365N, 365Q, 365W, 367F, 369C, 369D, 369F, 369G, 369H,
                  370E, 371D, 372F, J365, V365, V365B, V365J, V365P, V365V
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.map_wrapper}>
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d107720.59058628681!2d77.52503812919062!3d12.893096460332037!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae15995d5e7861%3A0x5ab0b5664313afa5!2sUNISEARCH!5e0!3m2!1sen!2sbd!4v1662535342722!5m2!1sen!2sbd"
            width="800"
            height="600"
            style={{ border: "0" }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </section>

      {/* section form */}
      {pageData && (
        <section id="book_your_slot" ref={ref}>
          <div className="container">
            <div className={styles.form_wrapper}>
              <LeadForm
                pageSlug="study-abroad-consultants-in-bangalore"
                pageData={pageData}
              />
            </div>
          </div>
        </section>
      )}

      {/* section review */}
      <section className={styles.section_review}>
        <div className="container">
          <>
            <div
              className={`${styles.review_slider_person} ReviewSliderPerson`}
            >
              <Slider
                {...settingsThumbs}
                asNavFor={nav1}
                ref={(slider) => setSlider2(slider)}
              >
                <div
                  className={`${styles.review_person_image_wrapper} review_person_image_wrapper`}
                >
                  <img
                    src={getAssets(
                      "assets/images/consultant/Shashank Reddy.jpg"
                    )}
                    alt="Shashank Reddy"
                  />
                </div>

                <div
                  className={`${styles.review_person_image_wrapper} review_person_image_wrapper`}
                >
                  <img
                    src={getAssets(
                      "assets/images/consultant/Shruti Sethna.jpg"
                    )}
                    alt="Shruti Sethna"
                  />
                </div>

                <div
                  className={`${styles.review_person_image_wrapper} review_person_image_wrapper`}
                >
                  <img
                    src={getAssets(
                      "assets/images/consultant/Kajal Shrivastava.jpg"
                    )}
                    alt="Kajal Shrivastava"
                  />
                </div>

                <div
                  className={`${styles.review_person_image_wrapper} review_person_image_wrapper`}
                >
                  <img
                    src={getAssets(
                      "assets/images/consultant/Vijaya Poorna.jpg"
                    )}
                    alt="Vijaya Poorna"
                  />
                </div>

                <div
                  className={`${styles.review_person_image_wrapper} review_person_image_wrapper`}
                >
                  <img
                    src={getAssets("assets/images/consultant/Saavn beli.jpg")}
                    alt="Saavn beli"
                  />
                </div>

                <div
                  className={`${styles.review_person_image_wrapper} review_person_image_wrapper`}
                >
                  <img
                    src={getAssets(
                      "assets/images/consultant/Ishaan Sharma.jpg"
                    )}
                    alt="Ishaan Sharma"
                  />
                </div>
              </Slider>
            </div>

            <div className={styles.total_review_wrapper}>
              <div className={styles.total_review_stars}>
                {/* <Rating
                  name="half-rating-read"
                  defaultValue={2.5}
                  precision={0.5}
                  readOnly
                /> */}
                <BsStarFill />
                <BsStarFill />
                <BsStarFill />
                <BsStarFill />
                <BsStarHalf />

                <div className={styles.rating}>4.5</div>
              </div>
              <div className={styles.total_review_text}>
                Based on 1600+ reviews
              </div>
            </div>

            {/* reveiw text */}
            <div className="ReviewSliderText">
              <Slider
                {...settingsMain}
                asNavFor={nav2}
                ref={(slider) => setSlider1(slider)}
              >
                <div className={styles.review_info_wrapper}>
                  <p className={styles.review_text}>
                    "Great Counseling firm with a very nice and cooperative
                    team. They helped me get into my dream university, from
                    application to visa. Big shout out to my counsellor who
                    helped me a lot and made this possible. Thank you UniSearch.
                    "
                  </p>
                  <div className={styles.review_divider}></div>
                  <div className={styles.review_name}>Shashank Reddy</div>
                  {/* <Rating name="rating-read" defaultValue={"4"} readOnly /> */}
                  <div className={styles.ratings_icons}>
                    <BsStarFill />
                    <BsStarFill />
                    <BsStarFill />
                    <BsStarFill />
                    <BsStarHalf />
                  </div>
                </div>

                <div className={styles.review_info_wrapper}>
                  <p className={styles.review_text}>
                    "Great Counseling offered by Saista. She counselled me
                    really well for the countries I can venture out with my
                    current profile.. Also she motivated me and counselled me
                    really well for the current USA Visa Rejection I have."
                  </p>
                  <div className={styles.review_divider}></div>
                  <div className={styles.review_name}>Shruti Sethna</div>
                  {/* <Rating name="rating-read" defaultValue={"4"} readOnly /> */}
                  <div className={styles.ratings_icons}>
                    <BsStarFill />
                    <BsStarFill />
                    <BsStarFill />
                    <BsStarFill />
                    <BsStarFill />
                  </div>
                </div>

                <div className={styles.review_info_wrapper}>
                  <p className={styles.review_text}>
                    "It was really beneficial and amazing experience. The staff
                    are really supportive throughout the process, from required
                    exams to the visa. They were available whenever you need
                    them, for their guidance. They put all there efforts for you
                    to get into your desired University."
                  </p>
                  <div className={styles.review_divider}></div>
                  <div className={styles.review_name}>Kajal Shrivastava</div>
                  {/* <Rating name="rating-read" defaultValue={"4"} readOnly /> */}
                  <div className={styles.ratings_icons}>
                    <BsStarFill />
                    <BsStarFill />
                    <BsStarFill />
                    <BsStarFill />
                    <BsStar />
                  </div>
                </div>

                <div className={styles.review_info_wrapper}>
                  <p className={styles.review_text}>
                    "Hi, I had a wonderful experience with UniSearch. Hina was
                    really helpful throughout my process. She provided me a lots
                    of information and cleared all my doubts whenever i needed
                    without any hesitation.Thank you Hina and UniSearch."
                  </p>
                  <div className={styles.review_divider}></div>
                  <div className={styles.review_name}>Vijaya Poorna</div>
                  {/* <Rating name="rating-read" defaultValue={"4"} readOnly /> */}
                  <div className={styles.ratings_icons}>
                    <BsStarFill />
                    <BsStarFill />
                    <BsStarFill />
                    <BsStarFill />
                    <BsStarHalf />
                  </div>
                </div>

                <div className={styles.review_info_wrapper}>
                  <p className={styles.review_text}>
                    "I had an amazing experience with them. From pre-application
                    to post-application they have been amazing. Especially my
                    counsellor who has great experience in the same and has been
                    a wonderful guide . Thanks a bunch :)"
                  </p>
                  <div className={styles.review_divider}></div>
                  <div className={styles.review_name}>Saavn beli</div>
                  {/* <Rating name="rating-read" defaultValue={"4"} readOnly /> */}
                  <div className={styles.ratings_icons}>
                    <BsStarFill />
                    <BsStarFill />
                    <BsStarFill />
                    <BsStarFill />
                    <BsStarFill />
                  </div>
                </div>

                <div className={styles.review_info_wrapper}>
                  <p className={styles.review_text}>
                    "The staff are really supportive throughout the process,
                    from required exams to the visa. They were available
                    whenever you need them, for their guidance. They put all
                    there efforts for you to get into your desired University.
                    It was really beneficial and amazing experience."
                  </p>
                  <div className={styles.review_divider}></div>
                  <div className={styles.review_name}>Ishaan Sharma</div>
                  {/* <Rating name="rating-read" defaultValue={"4"} readOnly /> */}
                  <div className={styles.ratings_icons}>
                    <BsStarFill />
                    <BsStarFill />
                    <BsStarFill />
                    <BsStarFill />
                    <BsStar />
                  </div>
                </div>
              </Slider>
            </div>
          </>
        </div>
      </section>

      {/* section faq */}
      <FAQSection
        isCollapsed={false}
        title="Frequently Asked Questions (FAQs)"
        faqData={faqData}
      />
    </Fragment>
  );
};

export default ConsultantsInBangalore;
